import React, { useCallback, useMemo } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import TextLink from 'components/Luxkit/TextLink'
import { SET_OPTIMIZELY_FEATURE_FLAG } from 'actions/actionConstants'
import BodyText from 'components/Luxkit/Typography/BodyText'
import SwitchButton from 'components/Luxkit/Switch/SwitchButton'
import Group from 'components/utils/Group'
import { formatOptimizelyTitle } from './ExperimentPanelHelpers'

interface FeatureFlagItemProps {
  flagKey: string
  enabled: boolean
}

function FeatureFlagItem({ flagKey, enabled }: FeatureFlagItemProps) {
  const dispatch = useAppDispatch()

  const handleToggle = useCallback(() => {
    dispatch({
      type: SET_OPTIMIZELY_FEATURE_FLAG,
      flagKey,
      value: !enabled,
    })
  }, [dispatch, flagKey, enabled])

  const title = useMemo(() => formatOptimizelyTitle(flagKey), [flagKey])

  return (
    <Group direction="vertical" gap={20}>
      <Group direction="vertical" gap={4}>
        <TextLink
          underline={false}
          href={`https://app.optimizely.com/v2/projects/24799170005/flags/manage/${flagKey}`}
          target="_blank"
          weight="regular"
        >
          {title}
        </TextLink>
        <BodyText variant="small" colour="neutral-three">
          {flagKey}
        </BodyText>
      </Group>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
        <BodyText variant="medium" colour="neutral-two">
          <i>Feature Flag</i>
        </BodyText>
        <SwitchButton checked={enabled} onChange={handleToggle}>
          {enabled ? 'On' : 'Off'}
        </SwitchButton>
      </Group>
    </Group>
  )
}

export default FeatureFlagItem
